import { render, staticRenderFns } from "./Television.vue?vue&type=template&id=27ab8e99&"
import script from "./Television.vue?vue&type=script&lang=js&"
export * from "./Television.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports